// @ts-check

import React from 'react';

import { formatDate } from 'core/utils';

/** @type {TableColumn} */
const cloneColumn = {
  id: 'clone_campaign',
  text: '',
  width: '8%',
  render: ({ row, col, cellValue, id, onClick }) => (
    <button
      type="button"
      className="clone-campaign-link btn btn-link p-0 fw-normal d-inline-flex align-items-center gap-1 text-decoration-underline"
      data-ga-event="link"
      data-ga-action="click"
      data-ga-name="onclick"
      data-ga-type="internal link"
      data-ga-region="main content"
      data-ga-section="Campaign Builder Home"
      data-ga-component=""
      data-ga-text={`Clone campaign: ${/** @type {any} */ (row).name}`}
      aria-label={`Clone campaign ${/** @type {any} */ (row).name}`}
      onClick={() => {
        onClick({ row, col, cellValue, id });
      }}
    >
      <i className="fa-regular fa-copy" aria-hidden="true" />
      <span>Clone</span>
    </button>
  ),
  textAlign: 'center',
};

/** @type {TableColumn[]} */
const baseColumns = [
  {
    id: 'name',
    text: 'Campaign Name',
    width: '45%',
    columnStyle: {
      minWidth: '320px',
    },
    cellStyle: {
      fontWeight: 'bold',
    },
    sortable: true,
  },
  {
    id: 'created_at',
    text: 'Date Created',
    width: '20%',
    format: (value) => formatDate(value),
    sortable: true,
  },
  {
    id: 'published',
    text: 'Status',
    width: '10%',
    dataType: 'boolean',
    componentType: 'badge',
    format: (value) => (value ? 'Published' : 'Saved'),
    computedValue: (value) => (value ? 'text-bg-success' : 'text-bg-info'),
    sortable: true,
  },
  {
    id: 'view_details',
    text: '',
    width: '15%',
    render: ({ row, col, cellValue, id, onClick }) => (
      <button
        type="button"
        className="btn btn-sm btn-dark"
        data-ga-event="link"
        data-ga-action="click"
        data-ga-name="onclick"
        data-ga-type="internal link"
        data-ga-region="main content"
        data-ga-section="Campaign Builder Home"
        data-ga-component=""
        data-ga-text={`View details for campaign: ${
          /** @type {any} */ (row).name
        }`}
        aria-label={`View details for campaign ${
          /** @type {any} */ (row).name
        }`}
        onClick={() => {
          onClick({ row, col, cellValue, id });
        }}
      >
        View Details
      </button>
    ),
    textAlign: 'center',
  },
];

/**
 * @param {{ enableCloneColumn?: boolean }} param0
 * @returns {TableColumn[]}
 */
const buildColumns = ({ enableCloneColumn = false }) => {
  const columns = [...baseColumns];
  // Increase View Details column width to 20% when Clone column is disabled.
  if (!enableCloneColumn) {
    return columns.map((col) =>
      col.id === 'view_details' ? { ...col, width: '20%' } : col,
    );
  }

  const viewDetailsIndex = columns.findIndex(
    (col) => col.id === 'view_details',
  );
  if (viewDetailsIndex === -1) {
    return [...columns, cloneColumn];
  }

  const updatedColumns = [...columns];
  updatedColumns.splice(viewDetailsIndex, 0, cloneColumn);
  return updatedColumns;
};

/**
 * @param {{ enableCloneColumn?: boolean }} param0
 * @returns {TableConfig}
 */
const buildRecentCampaignTableConfig = ({ enableCloneColumn = false }) => ({
  columns: buildColumns({ enableCloneColumn }),
  clientSorting: true,
  rowKeyId: 'campaign_id',
});

const recentCampaignTableConfig = buildRecentCampaignTableConfig({});

export { buildRecentCampaignTableConfig, recentCampaignTableConfig };
